import type React from "react";
import type { SiteSettingsUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import {
	getRequestPreviewMode,
	getRequestPreviewToken,
} from "#/_packages/umbrella/features/previews/utils/request-preview-mode.ts";
import { preloadRendererModules } from "#/_packages/umbrella/integrations/umbraco/utils/renderer-modules";
import umbBlocks from "#/_packages/umbrella/stylesheets/_umb-blocks-shared.css?url";
import umbBaseTheme from "#/_packages/umbrella/stylesheets/_umb-variables-base.css?url";
import umbCore from "#/_packages/umbrella/stylesheets/core.css?url";
import {
	getFavIconsFromSiteSettings,
	getFontsFromSiteSettings,
} from "#/_packages/umbrella/utils/seo-utils.ts";
import { getLayoutData } from "./layout-data.functions";

export async function getLayoutLoaderData() {
	const preview = await getRequestPreviewMode();
	const result = await getLayoutData({
		data: {
			preview,
			token: preview ? await getRequestPreviewToken() : undefined,
		},
	});
	await preloadRendererModules(result.globalSiteSettings);
	return result;
}

export function umbrellaMetaLinks(
	globalSiteSettings?: SiteSettingsUmbPageContentResponseModel,
): (
	| React.DetailedHTMLProps<
			React.LinkHTMLAttributes<HTMLLinkElement>,
			HTMLLinkElement
	  >
	| undefined
)[] {
	return [
		...getFontsFromSiteSettings(globalSiteSettings),
		...getFavIconsFromSiteSettings(globalSiteSettings),
		{ rel: "stylesheet", href: umbCore },
		{ rel: "stylesheet", href: umbBlocks },
		{ rel: "stylesheet", href: umbBaseTheme },
	];
}
